/**
 * Shared lead-stage colour map used across CustomersList, FollowUp, and all Reports.
 */
export const STAGE_BADGE = {
    "New Lead":      "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300",
    "Contacted":     "bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-300",
    "Qualified":     "bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300",
    "Proposal":      "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300",
    "Negotiation":   "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300",
    "Demo Fixed":    "bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300",
    "Demo Done":     "bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-300",
    "On Hold":       "bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400",
    "Unanswered":    "bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-400",
    "No Show":       "bg-rose-100 text-rose-600 dark:bg-rose-900/30 dark:text-rose-400",
    "Closed Won":    "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300",
    "Closed Lost":   "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300",
    "Dis-Qualified": "bg-red-50 text-red-500 dark:bg-red-900/20 dark:text-red-400",
    "Nurture Lead":       "bg-teal-100 text-teal-700 dark:bg-teal-900/30 dark:text-teal-300",
};

export const STAGE_BADGE_DEFAULT = "bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400";

export const getStageBadgeClass = (stage) =>
    STAGE_BADGE[stage] || STAGE_BADGE_DEFAULT;

// Active (selected) colours for filter badges above the table
const STAGE_FILTER_ACTIVE = {
    "New Lead":      "bg-blue-600 text-white border-blue-700",
    "Contacted":     "bg-cyan-600 text-white border-cyan-700",
    "Qualified":     "bg-purple-600 text-white border-purple-700",
    "Proposal":      "bg-orange-600 text-white border-orange-700",
    "Negotiation":   "bg-yellow-600 text-white border-yellow-700",
    "Demo Fixed":    "bg-indigo-600 text-white border-indigo-700",
    "Demo Done":     "bg-violet-600 text-white border-violet-700",
    "On Hold":       "bg-gray-600 text-white border-gray-700",
    "Unanswered":    "bg-slate-600 text-white border-slate-700",
    "No Show":       "bg-rose-600 text-white border-rose-700",
    "Closed Won":    "bg-green-600 text-white border-green-700",
    "Closed Lost":   "bg-red-600 text-white border-red-700",
    "Dis-Qualified": "bg-red-500 text-white border-red-600",
    "Nurture Lead":       "bg-teal-600 text-white border-teal-700",
};

// Inactive (unselected) colours for filter badges above the table
const STAGE_FILTER_INACTIVE = {
    "New Lead":      "bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 border-blue-200 dark:border-blue-800 hover:bg-blue-200",
    "Contacted":     "bg-cyan-100 dark:bg-cyan-900/30 text-cyan-800 dark:text-cyan-300 border-cyan-200 dark:border-cyan-800 hover:bg-cyan-200",
    "Qualified":     "bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300 border-purple-200 dark:border-purple-800 hover:bg-purple-200",
    "Proposal":      "bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-300 border-orange-200 dark:border-orange-800 hover:bg-orange-200",
    "Negotiation":   "bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300 border-yellow-200 dark:border-yellow-800 hover:bg-yellow-200",
    "Demo Fixed":    "bg-indigo-100 dark:bg-indigo-900/30 text-indigo-800 dark:text-indigo-300 border-indigo-200 dark:border-indigo-800 hover:bg-indigo-200",
    "Demo Done":     "bg-violet-100 dark:bg-violet-900/30 text-violet-800 dark:text-violet-300 border-violet-200 dark:border-violet-800 hover:bg-violet-200",
    "On Hold":       "bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-300 border-gray-200 dark:border-gray-700 hover:bg-gray-200",
    "Unanswered":    "bg-slate-100 dark:bg-slate-800 text-slate-800 dark:text-slate-300 border-slate-200 dark:border-slate-700 hover:bg-slate-200",
    "No Show":       "bg-rose-100 dark:bg-rose-900/30 text-rose-800 dark:text-rose-300 border-rose-200 dark:border-rose-800 hover:bg-rose-200",
    "Closed Won":    "bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 border-green-200 dark:border-green-800 hover:bg-green-200",
    "Closed Lost":   "bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300 border-red-200 dark:border-red-800 hover:bg-red-200",
    "Dis-Qualified": "bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-400 border-red-200 dark:border-red-800 hover:bg-red-100",
    "Nurture Lead":       "bg-teal-100 dark:bg-teal-900/30 text-teal-800 dark:text-teal-300 border-teal-200 dark:border-teal-800 hover:bg-teal-200",
};

const STAGE_FILTER_INACTIVE_DEFAULT = "bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-300 border-gray-200 dark:border-gray-700 hover:bg-gray-200";
const STAGE_FILTER_ACTIVE_DEFAULT   = "bg-gray-600 text-white border-gray-700";

/**
 * Returns the filter-badge class for a stage name (used above the table).
 * `stage` is the original-cased stage name e.g. "New Lead".
 * `isActive` is true when this filter is currently selected.
 */
export const getStageFilterClass = (stage, isActive) =>
    isActive
        ? (STAGE_FILTER_ACTIVE[stage]   || STAGE_FILTER_ACTIVE_DEFAULT)
        : (STAGE_FILTER_INACTIVE[stage] || STAGE_FILTER_INACTIVE_DEFAULT);

/**
 * Canonical stage order matching Forecast Configuration.
 * Stages not in this list are sorted to the end.
 */
export const STAGE_ORDER = [
    "New Lead", "Unanswered", "Contacted", "Qualified",
    "No Show", "Demo Fixed", "Demo Done", "Proposal",
    "Negotiation", "On Hold", "Closed Won", "Closed Lost", "Dis-Qualified", "Nurture Lead",
];

/**
 * Sorts an array of [stage, count] entries by STAGE_ORDER.
 */
export const sortStageEntries = (entries) =>
    [...entries].sort((a, b) => {
        const ai = STAGE_ORDER.indexOf(a[0]);
        const bi = STAGE_ORDER.indexOf(b[0]);
        const aIdx = ai === -1 ? 999 : ai;
        const bIdx = bi === -1 ? 999 : bi;
        return aIdx - bIdx;
    });
